(function() {
  var StepHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  exports.DropdownsHandler = (function(superClass) {
    extend(DropdownsHandler, superClass);

    function DropdownsHandler() {
      return DropdownsHandler.__super__.constructor.apply(this, arguments);
    }

    DropdownsHandler.prototype.inputSel = 'select';

    DropdownsHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      var option, optionID, optionName, optionValue, retval, selectedOption, value, yArray, zArray;
      yArray = this.taffyObjects.axes({
        name: 'Y'
      }).first().array;
      if (yArray === 'fields') {
        selectedOption = this.getInputEl({
          field: fieldID,
          aspect: aspectID
        }).find('option:selected');
      } else if (yArray === 'y_aspects') {
        selectedOption = this.getInputEl({
          aspect: aspectID
        }).find('option:selected');
      }
      value = selectedOption.attr('data-value');
      option = selectedOption.attr('data-option');
      optionValue = (value != null) && value !== '' ? parseInt(value) : null;
      optionID = (option != null) && option !== '' ? parseInt(option) : null;
      zArray = this.taffyObjects.axes({
        name: 'Z'
      }).first().array;
      optionName = this.taffyObjects[zArray]({
        id: optionID || optionValue
      }).first().display_name;
      retval = {
        value: optionValue,
        options_id: optionID,
        option_name: optionName
      };
      return retval;
    };

    DropdownsHandler.prototype.setFieldAspect = function(fieldAspect) {
      var input, ref, yArray;
      yArray = this.taffyObjects.axes({
        name: 'Y'
      }).first().array;
      if (yArray === 'fields') {
        input = this.getInputEl({
          field: fieldAspect.fields_id,
          aspect: fieldAspect.aspects_id
        });
      } else if (yArray === 'y_aspects') {
        input = this.getInputEl({
          aspect: fieldAspect.aspects_id
        });
      }
      return input.val((ref = fieldAspect.value) != null ? ref : fieldAspect.options_id);
    };

    return DropdownsHandler;

  })(StepHandler);

}).call(this);
